import * as React from 'react';
import { SVGProps } from 'react';

const ShieldHeartIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a)">
      <path d="M20 11.182c0 4.54-3.413 8.787-8 9.818-4.587-1.031-8-5.277-8-9.818v-3.94a2 2 0 0 1 1.243-1.85l5-2.046a4.637 4.637 0 0 1 3.514 0l5 2.046A2 2 0 0 1 20 7.242v3.94Z" />
      <path d="M12 9.642A1.874 1.874 0 0 1 13.437 9c1.234 0 2.063 1.117 2.063 2.158C15.5 13.333 12.692 15 12 15c-.692 0-3.5-1.667-3.5-3.842C8.5 10.117 9.328 9 10.563 9c.706 0 1.169.34 1.437.642Z" />
    </g>
  </svg>
);
export default ShieldHeartIcon;
